import styled from 'styled-components';

export const HiddenLabel = styled.label`
	display: none;
`;

export const HiddenInput = styled.input`
	display: none;
`;
